module.exports = __webpack_public_path__ + "static/img/title-jtjg-bg.fae11c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/title-jtjg-bg.png
// module id = s7SW
// module chunks = 1